module.exports = __webpack_public_path__ + "static/media/regimen-height.3149114b.svg";